import React from 'react';
import { IconChevronLeft, IconChevronRight } from '@tabler/icons-react';
import { monthGrid, monthLong, toDateKey } from '../../utils/date';

const DOW = ['MON', 'TUE', 'WED', 'THU', 'FRI', 'SAT', 'SUN'];

/**
 * Month view tuned for booking 2–3 weeks ahead: open days are bold with a dot
 * (teal = available, orange = few slots left); closed / fully booked days are muted.
 * dayMap: { 'YYYY-MM-DD': { status, slotsOpen } }
 */
export default function MonthCalendar({
  month, dayMap, selected, onSelect, onPrev, onNext, canPrev, canNext, loading,
}) {
  const cells = monthGrid(month.getFullYear(), month.getMonth());
  return (
    <div className={`calendar card ${loading ? 'calendar--loading' : ''}`}>
      <div className="calendar__head">
        <button type="button" className="calendar__nav" onClick={onPrev} disabled={!canPrev} aria-label="Previous month">
          <IconChevronLeft size={20} />
        </button>
        <span className="calendar__title">{`${monthLong(month)} ${month.getFullYear()}`}</span>
        <button type="button" className="calendar__nav calendar__nav--next" onClick={onNext} disabled={!canNext} aria-label="Next month">
          <IconChevronRight size={20} />
        </button>
      </div>
      <div className="calendar__grid" role="grid">
        {DOW.map((d) => <span key={d} className="calendar__dow">{d}</span>)}
        {cells.map((date, i) => {
          if (!date) return <span key={`pad-${i}`} />;
          const key = toDateKey(date);
          const info = dayMap[key];
          const open = info && (info.status === 'available' || info.status === 'few');
          const cls = [
            'calendar__day',
            open ? 'calendar__day--open' : 'calendar__day--off',
            info?.status === 'few' && 'calendar__day--few',
            selected === key && 'calendar__day--selected',
          ].filter(Boolean).join(' ');
          return (
            <button
              key={key}
              type="button"
              className={cls}
              disabled={!open}
              onClick={() => onSelect(key)}
              aria-label={`${date.getDate()} ${monthLong(date)}${open ? `, ${info.slotsOpen} slots open` : ', unavailable'}`}
              aria-pressed={selected === key}
            >
              <span>{date.getDate()}</span>
              {open && <i className="calendar__dot" />}
            </button>
          );
        })}
      </div>
      <div className="calendar__legend">
        <span><i className="calendar__dot" /> Available</span>
        <span><i className="calendar__dot calendar__dot--few" /> Few slots left</span>
        <span className="calendar__legend-off"><b>12</b> Fully booked / closed</span>
      </div>
    </div>
  );
}
